import React, { useContext } from "react";
import { createOrder, verifyPayment } from "../api/api";
import { AuthContext } from "../context/AuthContext";

export default function PaymentPage() {
  const { user, upgradeToPremium } = useContext(AuthContext);

  const handlePayment = async () => {
    try {
      const { data } = await createOrder(100);
      const order = data.data;

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY,
        amount: order.amount,
        currency: order.currency,
        name: "DSABuddy",
        description: "DSA Buddy Premium Subscription",
        order_id: order.id,
        handler: async function (response) {
          try {
            const verifyRes = await verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });

            if (verifyRes.data.success) {
              alert("Payment Successful ✅ Premium Unlocked!");
              upgradeToPremium(); // ✅ context update karega aur localStorage me save karega
            } else {
              alert("Payment Verification Failed ❌");
            }
          } catch (err) {
            console.error("Verification error:", err);
            alert("Payment verification failed ❌");
          }
        },
        prefill: {
          name: user?.name || "Guest",
          email: user?.email || "guest@example.com",
          contact: user?.phone || "9999999999",
        },
        notes: {
          address: "DSABuddy Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", (response) => {
        alert("Payment Failed ❌");
        console.error("Payment failed details:", response.error);
      });
      rzp.open();
    } catch (err) {
      console.error("Payment error:", err);
      alert("Something went wrong while creating payment ❌");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center mt-10">
      <h1 className="text-2xl font-bold mb-5">Buy Premium Access</h1>
      <button
        onClick={handlePayment}
        className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
      >
        Pay ₹100
      </button>
    </div>
  );
}
